import ProductIcon from "../icons/ProductIcon";

const Loader = ({ isLoader }) => {
  return (
    <>
      {(isLoader) && (
        <div className='d-flex justify-content-center align-items-center loader2-bg'>
          <div style={{ width: 150, height: 150, position: "relative" }} className='d-flex justify-content-center align-items-center'>
            <span className="loader2 bg-white"></span>
            <ProductIcon style={{ width: 100, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;
